import axios from 'axios';
import LoginService from '../acesso/login.service'
import NotaFiscalAvulsaService from '../nfse/notafiscalavulsa.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/declaracao/';

class Declaracao {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllDeclaracoes(idContribuinte, ano, mes) {
        return axios.get(API_URL + 'allDeclaracoes?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, { headers: this.headers });
    }

    findAllDeclaracoesNumero(idContribuinte, ano, mes, numero, filtro) {
        return axios.get(API_URL + 'allDeclaracoesNumero?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes + '&numero=' + numero + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllDeclaracoesPorPeriodo(idContribuinte, dataIni, dataFim) {
        return axios.get(API_URL + 'allDeclaracoesPorPeriodo?idContribuinte=' + idContribuinte + '&dataIni=' + dataIni + '&dataFim=' + dataFim, { headers: this.headers });
    }

    findAllDeclaracoesPorPeriodoNumero(idContribuinte, dataIni, dataFim, numero, filtro) {
        return axios.get(API_URL + 'allDeclaracoesPorPeriodoNumero?idContribuinte=' + idContribuinte + '&dataIni=' + dataIni + '&dataFim=' + dataFim + '&numero=' + numero + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllItensDeclaracao(idDeclaracao) {
        return axios.get(API_URL + 'allItensDeclaracao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    findAllNotasEmAberto(idContribuinte, ano, mes) {
        return axios.get(API_URL + 'allNotasFiscaisEmAberto?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, { headers: this.headers });
    }

    findAllNotasDeducao(documento, idContribuinte, ano, mes) {
        return axios.get(API_URL + 'allNotasFiscaisDeducao?documento=' + documento + '&idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, { headers: this.headers });
    }

    findAllNotasEmAbertoPorPeriodo(idContribuinte, dataIni, dataFim) {
        return axios.get(API_URL + 'allNotasFiscaisEmAbertoPorPeriodo?idContribuinte=' + idContribuinte + '&dataIni=' + dataIni + '&dataFim=' + dataFim, { headers: this.headers });
    }

    findBoletos(id) {
        return axios.get(API_URL + 'allBoletos?idDeclaracao=' + id, { headers: this.headers });
    }

    findBoletosTaxas(id, idCliente) {
        return axios.get(API_URL + 'allBoletosTaxas?idDeclaracao=' + id + '&idCliente=' + idCliente, { headers: this.headers });
    }

    findTaxas(idContribuinte, ano, mes, idBolDebito) {
        return axios.get(API_URL + 'allTaxas?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes + '&idBolDebito=' + idBolDebito, { headers: this.headers });
    }

    cancelarTaxa(idUsuario, idContribuinte, idCliente, ano, numero, motivo) {
        return axios.post(API_URL + 'cancelarTaxa?idUsuario=' + idUsuario + '&idContribuinte=' + idContribuinte + '&idCliente=' + idCliente + '&ano=' + ano + '&numero=' + numero + '&motivo=' + motivo, null,
            { headers: this.headers });
    }

    declarar(idCliente, idUsuario, idContribuinte, ano, mes, tipo, composicaoNotas) {
        return axios.post(API_URL + 'declaracaoNormal?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes + '&tipo=' + tipo, JSON.stringify(composicaoNotas),
            { headers: this.headers });
    }

    declararCompetenciaGeral(idCliente, idUsuario, idContribuinte, ano, mes) {
        return axios.post(API_URL + 'declaracaoCompetenciaGeral?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes, null,
            { headers: this.headers });
    }

    gerarDam(idCliente, idUsuario, idContribuinte, ano, mes, tipo, notasFiscais) {
        return axios.post(API_URL + 'gerarDamNormal?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes + '&tipo=' + tipo, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    editarDam(idUsuario, idDeclaracao, notasFiscais) {
        return axios.post(API_URL + 'editarDam?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    declararSemMov(idCliente, idUsuario, idContribuinte, ano, mes) {
        return axios.post(API_URL + 'declaracaoNormalSemMov?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes, null,
            { headers: this.headers });
    }

    desfazerCancelamento(idDeclaracao) {
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios.post(API_URL + 'desfazerCancelamento?idContribuinte=' + this.idContribuinte
            + '&idUsuario=' + this.idUsuario
            + '&idDeclaracao=' + idDeclaracao, null,
            { headers: this.headers });
    }

    cancelar(idUsuario, idContribuinte, idDeclaracao) {
        return axios.post(API_URL + 'cancelar?idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null,
            { headers: this.headers });
    }

    encerrar(idCliente, idUsuario, idContribuinte, idDeclaracao) {
        return axios.post(API_URL + 'encerrarDeclaracao?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null,
            { headers: this.headers });
    }

    encerrarComBeneficio(idUsuario, listItensDeclaracao) {
        return axios.post(API_URL + 'encerrarDeclaracaoBeneficio?idUsuario=' + idUsuario, listItensDeclaracao,
            { headers: this.headers });
    }

    retificar(idUsuario, idContribuinte, idCliente, idDeclaracao, notasFiscais) {
        return axios.post(API_URL + 'retificar?idUsuario=' + idUsuario + '&idContribuinte=' + idContribuinte + '&idCliente=' + idCliente + '&idDeclaracao=' + idDeclaracao, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    carregarNotasDeclaracao(idDeclaracao) {
        return axios.get(API_URL + 'allNotasDeclaracao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    competenciaEmFiscalizacao(idDeclaracao) {
        return axios.get(API_URL + 'competenciaEmFiscalizacao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    competenciaDamEmFiscalizacao(idDeclaracao) {
        return axios.get(API_URL + 'competenciaDamEmFiscalizacao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    atualizaVencimentoBoleto(tipoDam, idDamAgrupamento, idDeclaracao, dataVencimento) {
        if (idDeclaracao && idDeclaracao.startsWith && idDeclaracao.startsWith('DAM_')) {
            let idNotaAvulsa = idDeclaracao.replace('DAM_', '');
            return NotaFiscalAvulsaService.atualizarVencimento(idNotaAvulsa, dataVencimento);
        }
        if (tipoDam === 'A') {
            return this.atualizarVencimento(idDamAgrupamento, idDeclaracao, dataVencimento);
        } else {
            return this.atualizarVencimentoSimples(idDeclaracao, dataVencimento);
        }
    }

    atualizarVencimento(idDamAgrupamento, idDeclaracao, dataVencimento) {
        console.log("Agrupado");
        return axios.post(API_URL + 'atualizarVencimento?idDamAgrupamento=' + idDamAgrupamento + '&idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento, null, { headers: this.headers });
    }

    atualizarParcelaDam(tipoDam, idDamAgrupamento, idDeclaracao, dataVencimento, idUsuario) {
        console.log(tipoDam);
        return axios.post(API_URL + 'atualizarParcelaDam?idDamAgrupamento=' + idDamAgrupamento + '&idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento + '&idUsuario=' + idUsuario, null, { headers: this.headers });
    }

    criarPagamentoPix(idDamAgrupamento, idDeclaracao) {
        if (idDeclaracao && idDeclaracao.startsWith && idDeclaracao.startsWith('DAM_')) {
            let idNotaAvulsa = idDeclaracao.replace('DAM_', '');
            return NotaFiscalAvulsaService.criarPagamentoPix(idNotaAvulsa);
        }
        return axios.post(API_URL + 'criarPagamentoPix?idDamAgrupamento=' + idDamAgrupamento + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    criarPagamentoPixCp(idCalculoParcelado, idDeclaracao) {
        if (idDeclaracao && idDeclaracao.startsWith && idDeclaracao.startsWith('DAM_')) {
            let idNotaAvulsa = idDeclaracao.replace('DAM_', '');
            return NotaFiscalAvulsaService.criarPagamentoPixCp(idNotaAvulsa, idCalculoParcelado);
        }
        return axios.post(API_URL + 'criarPagamentoPixCp?idCalculoParcelado=' + idCalculoParcelado + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    consultarPagamentoPix(idDeclaracao, idDamAgrupamento) {
        if (idDeclaracao && idDeclaracao.startsWith && idDeclaracao.startsWith('DAM_')) {
            let idNotaAvulsa = idDeclaracao.replace('DAM_', '');
            return NotaFiscalAvulsaService.consultarPagamentoPix(idNotaAvulsa);
        }
        return axios.get(API_URL + 'consultarPagamentoPix?idDeclaracao=' + idDeclaracao + '&idDamAgrupamento=' + idDamAgrupamento, { headers: this.headers });
    }

    atualizarVencimentoSimples(idDeclaracao, dataVencimento) {
        console.log("Simples");
        return axios.post(API_URL + 'atualizarVencimentoSimples?idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento, null, { headers: this.headers });
    }

    carregarDadosCredito(idUsuario, idDeclaracao) {
        return axios.get(API_URL + 'carregarDadosCredito?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    aplicarCredito(idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'aplicarCredito?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    transferirCalculosDeclaracao(idDeclaracaoOrigem, numeroDeclaracaoDestino) {
        return axios.post(API_URL + 'transferirCalculosDeclaracao?idDeclaracaoOrigem=' + idDeclaracaoOrigem + '&numeroDeclaracaoDestino=' + numeroDeclaracaoDestino, null, { headers: this.headers });
    }

    suspenderGuia(idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'suspenderGuia?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    cancelarSuspencaoGuia(idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'cancelarSuspencaoGuia?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    getConsultaRelDamXls(dataIni, dataFim, numero, filtro) {
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'getConsultaDamRelatorioXls?idContribuinte=' + this.idContribuinte
            + '&dataIni=' + dataIni
            + '&dataFim=' + dataFim
            + '&numero=' + numero
            + '&filtro=' + filtro,
            { headers: this.headers });
    }

    getConsultaRelDecXlsComp(ano, mes, numero, filtro) {
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'getConsultaDecRelatorioXlsComp?idContribuinte=' + this.idContribuinte
            + '&ano=' + ano
            + '&mes=' + mes
            + '&numero=' + numero
            + '&filtro=' + filtro,
            { headers: this.headers });
    }

    obterCalculoDeclaracao(idDeclaracao) {
        return axios.get(API_URL + 'obterCalculoDeclaracao?idDeclaracao=' + idDeclaracao,
            { headers: this.headers });
    }

    obterDadosAutoInfracao(idDeclaracao){
        return axios.get(API_URL + 'obterAutoInfracao?idDeclaracao=' + idDeclaracao,
            { headers: this.headers });
    }

}

export default new Declaracao();